var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    {
      staticClass: "list-group list-group-flush",
      on: { scroll: _vm.onScrollBottom },
    },
    [
      _c(
        "li",
        { staticClass: "list-group-item d-flex flex-row align-items-center" },
        [
          _c("h6", { staticClass: "text-dark-gray m-0" }, [
            _vm._v("\n      " + _vm._s(_vm.titleText) + "\n    "),
          ]),
          _vm._v(" "),
          _vm.isBroker
            ? _c("agents-dropdown", {
                attrs: {
                  "preload-agents": false,
                  "show-all": "",
                  "selected-agent": _vm.selectedAgentUsername,
                },
                on: {
                  "update:selectedAgent": function ($event) {
                    _vm.selectedAgentUsername = $event
                  },
                  "update:selected-agent": function ($event) {
                    _vm.selectedAgentUsername = $event
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-center vertical-center h-100",
            },
            [
              _c("div", {
                staticClass: "spinner-border text-primary mb-5",
                staticStyle: { height: "5rem", width: "5rem" },
                attrs: { role: "status" },
              }),
            ]
          )
        : [
            !_vm.recentActivities.length
              ? _c(
                  "div",
                  { staticClass: "row justify-content-center" },
                  [
                    _c("no-results", { staticClass: "mx-4 my-3" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t(
                              "dashboard.messages.errors.noClientActivities"
                            )
                          ) +
                          "\n      "
                      ),
                    ]),
                  ],
                  1
                )
              : [
                  _vm._l(_vm.recentActivities, function (activity) {
                    return _c(
                      "li",
                      {
                        key: "activity-" + activity.clientActivityId,
                        staticClass: "list-group-item",
                      },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "pl-3 pr-0 img" },
                            [
                              _c(
                                "profile-avatar",
                                _vm._b(
                                  {
                                    staticClass: "img-fluid rounded-circle lg",
                                    attrs: {
                                      "avatar-options": { inline: false },
                                    },
                                  },
                                  "profile-avatar",
                                  Object.assign(
                                    {},
                                    activity.accountDetails,
                                    activity.metadata
                                  ),
                                  false
                                )
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col align-self-center comment-section",
                            },
                            [
                              _c("h6", { staticClass: "text-dark-gray" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm._f("splitMessage")(
                                        activity.message,
                                        activity.metadata,
                                        "main"
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              Object.keys(activity.metadata).length > 4
                                ? _c(
                                    "h6",
                                    { staticClass: "text-gray font-sm" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm._f("splitMessage")(
                                              activity.message,
                                              activity.metadata,
                                              "secondary"
                                            )
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "activity-options col-12 col-xl-4 d-flex flex-column justify-content-between",
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "text-light-gray bold time-ago mb-0",
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm._f("formatTimeAgo")(
                                          activity.createdAt
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              activity.type !== "new-client-signup"
                                ? _c(
                                    "client-activity-anchor",
                                    {
                                      attrs: {
                                        "account-details":
                                          activity.accountDetails,
                                        type: activity.type,
                                        metadata: activity.metadata,
                                        "client-activity-id":
                                          activity.clientActivityId,
                                      },
                                      on: { "open-file": _vm.downloadFile },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "view-comment bold" },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.buttonText(activity.type)
                                              )
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.loadingClients ? _c("client-activity-loader") : _vm._e(),
                ],
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }